export default __webpack_public_path__ + "static/media/arrow-ios-forward-outline.cfd64fa6.svg";